<template>
  <Modal name="DELETE_ITEM_MODAL" :title="title" actions>
    <template v-slot:body>
      <p class="mb-1">{{ $t('item.hints.delete') }}</p>
      <p class="font-weight-bold warning--text" dark>
        {{ $t('item.hints.deleteWarning') }}
      </p>
      <v-card class="pa-5 mt-5 grey lighten-3" outlined>
        <v-progress-linear v-if="isItemLoading" indeterminate />
        <span v-else>
          {{ item ? item.name : '---' }}
        </span>
      </v-card>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeAllModals"
        :disabled="isItemLoading"
        class="mr-5"
        large
        text
      >
        {{ $t('item.action.cancel') }}
      </v-btn>

      <v-btn
        @click="removeItem(item.id)"
        :loading="isItemLoading"
        class="red"
        large
        dark
        text
      >
        {{ $t('item.action.delete') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import Modal from '@/components/app/Modal'

export default {
  name: 'ItemDelete',

  components: {
    Modal,
  },

  computed: {
    ...mapGetters(['item', 'isItemLoading']),
  },

  data() {
    return {
      title: this.$t('item.action.delete'),
    }
  },

  methods: {
    ...mapMutations(['closeAllModals']),
    ...mapActions(['removeItem']),
  },
}
</script>
